/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaEventoPayload } from './pratica-evento-payload';


export interface TransizionePayload extends PraticaEventoPayload { 
    motivo?: string;
}

